import { render, staticRenderFns } from "./LatteBtn.vue?vue&type=template&id=1c1f4248&"
import script from "./LatteBtn.vue?vue&type=script&lang=js&"
export * from "./LatteBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports